export const CURRENCIES = [
  { code: "GBP", symbol: "£", name: "British Pound" },
  { code: "USD", symbol: "$", name: "US Dollar" },
  { code: "EUR", symbol: "€", name: "Euro" },
  { code: "JPY", symbol: "¥", name: "Japanese Yen" },
  { code: "CNY", symbol: "¥", name: "Chinese Yuan" },
  { code: "INR", symbol: "₹", name: "Indian Rupee" },
  { code: "AUD", symbol: "A$", name: "Australian Dollar" },
  { code: "CAD", symbol: "C$", name: "Canadian Dollar" },
  { code: "CHF", symbol: "Fr", name: "Swiss Franc" },
  { code: "SGD", symbol: "S$", name: "Singapore Dollar" },
  { code: "HKD", symbol: "HK$", name: "Hong Kong Dollar" },
  { code: "AED", symbol: "د.إ", name: "UAE Dirham" },
  { code: "NZD", symbol: "NZ$", name: "New Zealand Dollar" },
  { code: "SEK", symbol: "kr", name: "Swedish Krona" },
  { code: "NOK", symbol: "kr", name: "Norwegian Krone" },
  { code: "MXN", symbol: "Mex$", name: "Mexican Peso" },
  { code: "BRL", symbol: "R$", name: "Brazilian Real" },
  { code: "ZAR", symbol: "R", name: "South African Rand" },
];

export const getCurrencySymbol = (code) => {
  const c = CURRENCIES.find((x) => x.code === code);
  return c ? c.symbol : code;
};

// Default cost lines applied to every new template
export const DEFAULT_COST_LINES = [
  { id: "shipping", label: "Shipping", type: "percent", value: 25, base: "cost" },
  { id: "customs", label: "Customs Duty", type: "percent", value: 0, base: "cost_plus_shipping" },
  { id: "vat", label: "Import VAT", type: "percent", value: 20, base: "cost_plus_shipping_customs" },
];

export const DEFAULT_MARGIN = 30; // %

// Base options for a cost line. base indicates which running total it's applied to
export const BASE_OPTIONS = [
  { value: "cost", label: "Cost only" },
  { value: "cost_plus_shipping", label: "After Shipping" },
  { value: "cost_plus_shipping_customs", label: "After Shipping + Customs" },
  { value: "running", label: "Running total" },
];

export const STORAGE_KEYS = {
  TEMPLATES: "cargoprice_templates",
  ACTIVE_TEMPLATE: "cargoprice_active_template",
  SETTINGS: "cargoprice_settings",
  FX_CACHE: "cargoprice_fx_cache",
};
